import React from "react";
import { useTranslation } from "react-i18next";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";

/** Renders the loading element */
function Loading() {
  const { t } = useTranslation();
  return (
    <div className="flex-container">
      <h6>
        <HourglassEmptyIcon />
        {t("Common.Loading")}
      </h6>
    </div>
  );
}

export default Loading;
